var map = {
	"./decidim/challenges/decidim_challenges_icon.svg": 6437,
	"./decidim/sdgs/ods-01.svg": 3254,
	"./decidim/sdgs/ods-02.svg": 5685,
	"./decidim/sdgs/ods-03.svg": 4516,
	"./decidim/sdgs/ods-04.svg": 9195,
	"./decidim/sdgs/ods-05.svg": 4586,
	"./decidim/sdgs/ods-06.svg": 2697,
	"./decidim/sdgs/ods-07.svg": 8456,
	"./decidim/sdgs/ods-08.svg": 3724,
	"./decidim/sdgs/ods-09.svg": 2910,
	"./decidim/sdgs/ods-10.svg": 164,
	"./decidim/sdgs/ods-11.svg": 2773,
	"./decidim/sdgs/ods-12.svg": 902,
	"./decidim/sdgs/ods-13.svg": 4727,
	"./decidim/sdgs/ods-14.svg": 5544,
	"./decidim/sdgs/ods-15.svg": 7289,
	"./decidim/sdgs/ods-16.svg": 5914,
	"./decidim/sdgs/ods-17.svg": 6283,
	"./decidim/sdgs/sdg-wheel.png": 8192,
	"./decidim/sdgs/un_emblem_square.png": 3365
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5226;